import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { BrowserRouter as Router, Route, Switch, NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import ScrollToTop from './All/ScrollToTop';

import Landing from './Landing/Landing';
import Pattern from './All/Pattern';
import Footer from './All/Footer';
import NavHome from './All/NavHome';

import Work from './Work';
import Project from './Project/Project';
import Space from './Space';
import Info from './Info';
import Subscribed from './Subscribed';
import Loading from './Loading';
import NoMatch from './NoMatch';

class App extends Component {
    constructor() {
        super();
        this.svgSupport = ((a, b) => {
            return !!((b = 'createElementNS') in (a = document) && a[b]('http://www.w3.org/2000/svg', 'svg').createSVGRect)
        })();
        this.state = {
            dataReady: false
        };
    }

    componentWillMount() {
        this.fetchData();
    }

    fetchData() {
        const url = "https://cdn.contentful.com/spaces/xy2fjp11pr2d/entries?access_token=542b0f32cf4d5c34d9bb80427aea47612c3610680d7acf44c1783d6115336fb6";
        fetch(url, { method: "GET" }).then((res) => {
            return res.json();
        }).then((data) => {
            window.data = data;
            const projects = this.getItems(data, "project");
            const projectCats = _
                .chain(projects)
                .map((o) => {
                    return o.category;
                })
                .flatten()
                .uniq()
                .value();
            const events = this.getItems(data, "event");
            const pinned = data.items.filter((o) => {
                return o.sys.contentType.sys.id === "pinnedEvent";
            });
            const pinnedId = pinned[0].fields.happening.sys.id;
            const pinnedEvent = _.find(events, (item) => {
                return item.id === pinnedId;
            });
            const pastOrFuture = this.pastOrFuture(pinnedEvent.date);
            const members = this.getItems(data, "member");
            // there should only be one match for infoPage, and no need for .sys, only .fields
            const infoContent = this.getItems(data, "infoPage")[0];
            console.log(projects, events, members, infoContent);
            this.setState({ events, projects, pinnedEvent, pastOrFuture, members, infoContent, projectCats, dataReady: true });
        })
    }

    pastOrFuture(date) {
        const now = moment();
        const eventTime = moment(date);
        const diff = eventTime.diff(now);
        return diff > 0 ? "future" : "past";
    }

    getItems(data, type) {
        const arr = data.items.filter(function(item) {
            return item.sys.contentType.sys.id === type;
        });
        return this.getAssetUrls(data, arr);
    }

    getAssetUrls(data, arr) {
        return arr.map((item) => {
            const { fields } = item;
            fields.id = item.sys.id;
            if (item.fields.images) {
                item.fields.images.map((img, i) => {
                    const index = _.findIndex(data.includes.Asset, function(o) {
                        return o.sys.id === img.sys.id;
                    });
                    const baseUrl = data.includes.Asset[index].fields.file.url;
                    // provided the format is this
                    // //images.contentful.com/xy2fjp11pr2d/5qgQq1b8T6u6AI2oCeuCg2/288d105e0e4862276be9761bc8aa75ad/7X1B1577.jpg
                    const type = _.last(baseUrl.split("."));
                    fields.images[i].imgType = type;
                    const url = type === "gif" ? baseUrl + "?fit=fill" : baseUrl + "?fm=jpg&fl=progressive&fit=fill";
                    fields.images[i].url = url;
                    return true;
                });
            } else {
                console.log(item.fields.title);
            }
            return fields;
        });
    }

    render() {
        return (
            <Router>
              <ScrollToTop>
                <div id="App">
                  <Pattern />
                  <div id="frame" />
                  <div className="Nav">
                    <ul className="nav-list">
                      <li className={this.svgSupport ? "" : "png-fallback"}>
                        <NavLink exact to="/">{this.svgSupport && <NavHome/>}</NavLink>
                      </li>
                      <li><NavLink activeClassName="activeNav" to="/work">Work</NavLink></li>
                      <li><NavLink activeClassName="activeNav" to="/space">Art Space</NavLink></li>
                      <li><NavLink activeClassName="activeNav" to="/info">Info</NavLink></li>
                      <li><HashLink to="/info#contact">Contact</HashLink></li>
                    </ul>
                  </div>
                  <Switch>
                    <Route exact path="/" render={()=>
                      this.state.dataReady ?
                      <Landing
                        event={this.state.pinnedEvent}
                        pastOrFuture={this.state.pastOrFuture}
                        intro={this.state.infoContent.homeShortDescription}
                      /> :
                      <Loading /> }
                    />
                    <Route path="/work/:slug" render={({match})=>
                      this.state.dataReady ?
                      <Project project={_.find(this.state.projects, (o) => o.slug === match.params.slug)}/> :
                      <Loading /> }
                    />
                    <Route path="/work" render={()=>
                      this.state.dataReady ?
                      <Work projects={this.state.projects} categories={this.state.projectCats}/> :
                      <Loading /> }
                    />
                    <Route path="/space/:slug" render={({match})=>
                      this.state.dataReady ?
                      <Space allhappenings={this.state.events} happening={_.find(this.state.events, (o) => o.slug === match.params.slug)}/> :
                      <Loading /> }
                    />
                    <Route path="/space" render={()=>
                      this.state.dataReady ?
                      <Space allhappenings={this.state.events} happening={this.state.pinnedEvent}/> :
                      <Loading /> }
                    />
                    <Route path="/info" render={()=>
                      this.state.dataReady ?
                      <Info members={this.state.members} content={this.state.infoContent}/> :
                      <Loading /> }
                    />
                    <Route path="/newsletter-almost-done" component={Subscribed}/>
                    <Route path="/404" component={NoMatch}/>
                    <Route component={NoMatch} />
                  </Switch>
                  <Footer />
                </div>
              </ScrollToTop>
          </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js